import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { isNullOrUndefined } from 'util';
import { tConsultCertModel, tConsultCertModelPrint } from 'src/app/models/tConsultCertModel';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { GenderModel } from 'src/app/models/SimpleConfigModel';

import { MatTableDataSource, ShowOnDirtyErrorStateMatcher } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { SimpleConfigService } from 'src/app/services/SimpleConfig.service';
import { Gender } from 'src/app/models/non-master-model/Gender';
import { tPatientService } from 'src/app/services/tPatient.service';
import { tPatientModel } from 'src/app/models/tPatientModel';

import { tShopService } from 'src/app/services/tShop.service';
import { tShopModel } from 'src/app/Models/tShopModel';

import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { GetPrescNumByConsultNumInterface, tPrescriptionService } from 'src/app/services/tPrescription.service';

@Component({
  selector: 'app-prescription-cert',
  templateUrl: './prescription-cert.component.html',
  styleUrls: ['./prescription-cert.component.css']
})
export class PrescriptionCertComponent implements OnInit {

   @ViewChild('autoClick') autoClick: ElementRef;

 // picFullPath = './assets/img/print/doc_logo.png';
 // picFullPath_SignShop2 = './assets/img/print/signShop2.png';

 urlStartingPath = AppSettings.shopAdapter.imagePath;
 signShop2Path = this.urlStartingPath+"/assets/img/print/signShop2.png";
 picFullPath = this.urlStartingPath+"/assets/img/print/doc_logo.png";

 // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';

 isHiddenShop2Sign = false;
 isHiddenDefaultSign = false;

 TAG = 'SickLeaveCertComponent';

 isHiddenShop1Info = true;
 isHiddenShop2Info = true;


 showEng = false;


 @Input() action: string;
 @Input() status: string;
 @Input() tableKeyValue: string;
 @Input() msg: string;
 @Input() searchFilter: number;
 @Input() docType: number;
 @Input() genderList: GenderModel[];


 onConsultDataList: tConsultHeadModelWithPatientInfo;

 patientTitle_selection;
 patientGender_selection;

 printCertList: tConsultCertModelPrint;


 patientGender_selection_Display = '';
 shopAddressEng1='';
 shopAddressEng2='';
 shopAddressEng3='';
 shopAddress1='';
 shopAddress2='';
 shopAddress3='';
 shopPhone='';
 shopFax='';
 shopNameTC = '';
  HKIDStr='';

  prescList='';

 constructor(
   private router: Router,
   public activeModal: NgbActiveModal,
   private tOnConsultService: tOnConsultService,
   private dateTimeConvertService: DateTimeConvertService,
   private tEmployeeService: tEmployeeService,
   public datepipe: DatePipe,
   private SimpleConfigService:SimpleConfigService,
   private tPatientService: tPatientService,
   private tShopService: tShopService,
   private CrypService: CrypService,
   private prescService : tPrescriptionService
   ) { }

 ngOnInit() {

    this.getShopInfo(NavigationComponent.selectedShopID.toString());
   this.printCertList = new tConsultCertModelPrint();

   this.setDefaultLanguageString(AppComponent.usingLanguage);
   this.onConsultDataList = JSON.parse(localStorage.getItem('onConsultModel'));
   console.table(this.onConsultDataList);
   this.getPrescNumByConsultNum(this.onConsultDataList.clthConsultNumber);
   this.getOnConsultInfo();

   if (NavigationComponent.selectedShopID.toString() === '2') {
     this.isHiddenShop2Sign = false;
     this.isHiddenDefaultSign = true;
   } else {
     this.isHiddenShop2Sign = true;
     this.isHiddenDefaultSign = false;
   }


   if (NavigationComponent.selectedShopID.toString() === '2') {
     this.isHiddenShop1Info = true;
     this.isHiddenShop2Info = false;
   } else {
     this.isHiddenShop1Info = false;
     this.isHiddenShop2Info = true;
   }

 }
 ngAfterViewInit() {
   let inputElement: HTMLElement = this.autoClick.nativeElement as HTMLElement;
   setTimeout(() => {
     inputElement.click();
   //  this.activeModal.close('Close click');
     // And any other code that should run only after 5s
   }, 600);
}

getPrescNumByConsultNum(consultNumber:string){
  //this.prescList
  this.prescService.GetPrescNumByConsultNum(consultNumber).subscribe(res=>
    {
      if(res.length > 0){
        this.prescList = res.map(z=>z.prescNumber).join();
      }else{
        this.prescList = "";
      }
    });
}

 getOnConsultInfo() {
   // tslint:disable-next-line:max-line-length
   this.tOnConsultService.getOnConsultInfo(this.onConsultDataList.shopID, this.onConsultDataList.clthConsultNumber).subscribe(data => {

     this.onConsultDataList = data[0];

     for(var i = 0 ; i < this.genderList.length ; i++){

       if(this.onConsultDataList.patientGender == this.genderList[i].id){

         if(this.showEng == false){
           this.patientGender_selection_Display = this.genderList[i].chineseName;

         }else{
           this.patientGender_selection_Display = this.genderList[i].engName;

         }
       }
     }

     this.loadPatientData();
     this.getSavedConsultCert();
   });

 }

 getSavedConsultCert() {
   this.tOnConsultService.getSavedConsultCert(NavigationComponent.selectedShopID.toString(),
     this.onConsultDataList.clthConsultNumber, this.onConsultDataList.patientID).subscribe((data: any) => {

       if (!isNullOrUndefined(data[0])) {
         // this.log.d(this.TAG, 'getSavedConsultCert: ' + JSON.stringify(data[0]));
         this.printCertList = data[0];

         const dbStartDate = this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['prescriptionPrintDate'].toString()));
         const dbEndDate = this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['endDate'].toString()));

         const dbArrDate = this.dateTimeConvertService.ConvertCurrentDBDay(
           new Date(this.onConsultDataList.clthArrivalDateTime.toString()));


         this.printCertList.startDatePrint = dbStartDate;
         this.printCertList.endDatePrint = dbEndDate;
         this.printCertList.ArrivalDatePrint = dbArrDate;
         this.printCertList.printDate=this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['prescriptionPrintDate'].toString()));



         if (!isNullOrUndefined(this.printCertList.therapistID)) {
           this.tEmployeeService.getDataById(
             1, // NavigationComponent.selectedShopID,
             this.printCertList.therapistID.toString()).subscribe(therapisdata => {

               this.printCertList.therapistName = therapisdata.employeeChiName ;
               this.printCertList.regNo1 = therapisdata.drCMP;
               this.printCertList.regNo2 = therapisdata.drRegNo;
               this.printCertList.doctorRemark=therapisdata.employeeRemark3;
               if (this.printCertList.regNo2 !== '006712') {
                 this.isHiddenShop2Sign = true;
               }

           });

         }
       }

     });
 }


 setDefaultLanguageString(language: String){
   switch(language) {
     case SystemDefaultModel.Language_Chinese:

       this.showEng = false;
       break;
     case SystemDefaultModel.Language_English:

       this.showEng = true;

       break;
     default:

       this.showEng = false;

       break;
   }
 }

 cancel() {
   // this.log.i(this.TAG, "do cancel");
   this.activeModal.close('Close click');
 }

 isShowAPM(text: any) {

   if (isNullOrUndefined(text))
   {
     return false;
   }


   return true;

 }



 changeFont(className:string, operator:string){

   console.log("doing changeFont operator = "+operator);
   let element: any;
 //  let element2: any;

     element = document.getElementById(className);

     var style = window.getComputedStyle(element, null).getPropertyValue('font-size');
     var fontSize = parseFloat(style);

     if(operator === '+'){
       element.style.fontSize = (fontSize + 1) + 'px';

     }else{
       element.style.fontSize = (fontSize - 1) + 'px';

     }

 }


 getShopInfo(shopID: string) {
  this.tShopService.getDataById(shopID).subscribe(
    (res: any) => {
      this.shopAddressEng1=res.shopAddressEng1;
      this.shopAddressEng2=res.shopAddressEng2;
      this.shopAddressEng3=res.shopAddressEng3;
      this.shopAddress1=res.shopAddress1;
      this.shopAddress2=res.shopAddress2;
      this.shopAddress3=res.shopAddress3;
      this.shopPhone=res.shopPhone;
      this.shopFax=res.shopFax;
      this.shopNameTC = res.shopName;
      // this.shopList = res;
      // this.shopName = this.shopList[0].shopName.toString();
      // console.log('shopList = ' + JSON.stringify(res));
      // console.log('shopList = ' + this.shopList[0].shopName.toString());
    },
    err => {
      console.log(err);
    },
  );
}

loadPatientData() {
  this.tPatientService.getDataById(NavigationComponent.selectedShopID.toString(), this.onConsultDataList.patientID).subscribe(data => {



    const patientIHKID = data.patientIHKID.toString();
    var decrypted = this.CrypService.decryptStr(patientIHKID).toString();
    this.HKIDStr=decrypted;

  });
}

getPatientName(){
  var nameString='';
  if(this.onConsultDataList.patientChiName!=null || this.onConsultDataList.patientChiName!=''){
    nameString+=this.onConsultDataList.patientChiName+' '
  }
  if(this.onConsultDataList.patientSurname!=null || this.onConsultDataList.patientSurname!=''){
    nameString+=this.onConsultDataList.patientSurname+' '
  }
  
  if(this.onConsultDataList.patientChiName==this.onConsultDataList.patientSurname){
    nameString=this.onConsultDataList.patientChiName;
  }


  return nameString;
}


}
